export default {
  blog: () => import("/vercel/path0/layouts/blog.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m),
  pages: () => import("/vercel/path0/layouts/pages.vue").then(m => m.default || m)
}